export const money = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const hoy = () => new Date().toLocaleDateString("sv-SE");
export const TIPO_LABEL = { ingreso: "Ingreso", egreso: "Egreso", traspaso_salida: "Traspaso ↗ salida", traspaso_entrada: "Traspaso ↙ entrada" };
